import Grid from '@mui/material/Grid';
import React from 'react';

import { CANCEL_BUTTON } from '../../../shared/strings';
import BackButton from '../../../ui/BackButton/BackButton';
import Button from '../../../ui/Button/Button';
import PageTitle from '../../../ui/PageTitle/PageTitle';
import { TEXT_CONTENT_IDS } from '../../../utils/element-ids';
import type { UnifiedPaymentFormEntryProps } from '../../UnifiedPaymentForm/UnifiedPaymentFormEntry';

const {
  SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_SUB_TITLE,
  SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_BACK_BUTTON,
  SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_CANCEL_BUTTON,
} = TEXT_CONTENT_IDS;

export type SycurioTelephonicViewContainerProps = Pick<
  UnifiedPaymentFormEntryProps,
  'userJourney' | 'backButtonLabel' | 'onBackClick'
> & {
  showActionsOnForm: boolean | undefined;
  title: string;
  titleTestId?: string;
  subTitle?: string;
  sycurioFragmentUrl: string;
  isSycurioReady: boolean;
  sycurioPageHeight: string | undefined;
  onCancelHandler: () => void;
};

const SycurioTelephonicViewContainer: React.FC<
  SycurioTelephonicViewContainerProps
> = ({
  showActionsOnForm,
  backButtonLabel,
  onBackClick,
  title,
  titleTestId,
  subTitle,
  sycurioFragmentUrl,
  isSycurioReady,
  sycurioPageHeight,
  onCancelHandler,
}) => {
  return (
    <Grid
      container
      flexDirection="column"
      flexWrap="nowrap"
      height="100%"
      spacing={1}
    >
      <Grid>
        {showActionsOnForm && onBackClick ? (
          <BackButton
            label={backButtonLabel}
            onClick={onBackClick}
            testId={
              SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_BACK_BUTTON
            }
          />
        ) : null}
        <PageTitle
          title={title}
          titleId={titleTestId}
          subTitle={subTitle}
          subTitleId={
            SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_SUB_TITLE
          }
        />
      </Grid>
      <Grid flex={1}>
        {isSycurioReady ? (
          <iframe
            src={sycurioFragmentUrl}
            title="sycurio-iframe"
            data-testid="sycurio-iframe"
            style={{
              border: 'none',
              flexGrow: 1,
              margin: 0,
              padding: 0,
              width: '100%',
              height: sycurioPageHeight,
            }}
          />
        ) : null}
      </Grid>
      {showActionsOnForm ? (
        <Grid
          container
          direction="column"
        >
          <Button
            isLoading={false}
            onClick={onCancelHandler}
            variant="contained"
            color="secondary"
            id={
              SYCURIO_PAYMENT_METHOD_AGENT_CONTROL_PANEL_CANCEL_BUTTON
            }
          >
            {CANCEL_BUTTON}
          </Button>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default SycurioTelephonicViewContainer;
